module.exports = __webpack_public_path__ + "static/media/adminBg.db1fd997.svg";